<template>
    <VHint :active="!!hint" :text="hint">
        <div class="button-image" :class="{ 'blue-bg': blue, 'disabled': disabled }">
            <!-- <SvgIcon :path="src" /> -->
            <!-- <VIcon icon="plus" /> -->
            <simple-svg :src="src" :width="size" :height="size" :custom-class-name="customClass" />
            <!-- <div class="icon" v-html="src"></div> -->
            <!-- <img :src="src" alt="button" /> -->
        </div>
    </VHint>
</template>

<script>
import VHint from '../layout/VHint.vue';
// import {SimpleSVG} from 'vue3-simple-svg'

export default {
    name: 'ImageButton',

    components: {
        VHint,
        // SimpleSVG
    },

    computed: {
        customClass() {
            if (this.blue) return 'icon-blue icon';
            return this.redHover ? 'icon-red-hover icon' : this.red ? 'icon-red' : 'icon'
            //return this.red ? 'icon-red' : 'icon'
        }
    },

    props: {
        src: {
            type: String,
        },
        hint: {
            type: String,
            default: null,
        },
        red: {
            type: Boolean,
            default: false
        },
        redHover: {
            type: Boolean,
            default: false
        },
        blue: {
            type: Boolean,
            default: false
        },
        size: {
            type: String,
            default: "25"
        },
        disabled: {
            type: Boolean,
            default: false
        },
        fill: {
            type: Boolean,
            default: false
        }
    }
}
</script>

<style lang="scss">
.button-image {
    display: flex;
    align-items: center;
    justify-content: center;
    box-sizing: border-box;
    width: calc(v-bind(size) + 4px * 2);
    height: calc(v-bind(size) + 4px * 2);
    padding: 4px;
    border-radius: 5px;
    overflow: hidden;

    .icon {

        path {
            stroke: var(--color-text);
        }
    }

    .icon-blue {
        path {
            stroke: var(--color-blue) !important;
        }
    }

    &:hover {
        background-color: var(--color-bg-light);
        cursor: pointer;

        .icon-red-hover {
            path {
                stroke: var(--color-red) !important;
            }
        }
    }

    &:active {
        background-color: var(--color-bg-light);
        cursor: pointer;

        .icon {
            path {
                stroke: var(--color-blue-light) !important;
            }
        }

        .icon-red-hover {
            path {
                stroke: var(--color-red-light) !important;
            }
        }
    }

    &.disabled {
        opacity: 0.4;
        pointer-events: none;
        cursor: not-allowed;
    }

    &.blue-bg {
        background-color: var(--color-blue);

        .icon-blue {
            path {
                stroke: var(--color-btn-text) !important;
            }
        }

        &:hover {
            opacity: 0.9;
            background-color: var(--color-blue);
        }

        &:active {
            opacity: 0.8;
            background-color: var(--color-blue);
        }
    }

    svg-icon {
        width: 100%;
        height: 100%;
    }
}
</style>
